module.exports = __webpack_public_path__ + "static/media/pen1.474b182c.jpg";